const noJSON = {
  //Languages
  English: 'Engelsk',
  Norwegian: 'Norsk',

  //Login
  Email: 'E -post',
  Password: 'Passord',
  Login: 'Logg Inn',
  'Forgot password?': 'Glemt passord?',
  'Set your password below': 'Angi passordet ditt nedenfor',
  'Your password has been set. Click here to login':
    'Passordet ditt er angitt. Klikk her for å logge inn',
  'The password field is required.': 'Passordfeltet er obligatorisk.',
  'The confirm password field is required.':
    'Bekreft passord-feltet er påkrevd.',
  'Passwords must match': 'Passordene må være like',
  'The email field is required.': 'E-postfeltet er obligatorisk.',
  'Request password reset': 'Be om tilbakestilling av passord',
  'Password reset request submitted successfully. Please check your mail':
    'Forespørsel om tilbakestilling av passord sendt. Vennligst sjekk e-posten din',
  'Set your new password below': 'Angi ditt nye passord nedenfor',

  //Dashboard Page
  Robots: 'Roboter',
  All: 'Alle',
  Critical: 'Kritisk',
  Alarms: 'Alarmer',
  'My assigned robots': 'Mine tildelte roboter',
  'Assign robots in list to me': 'Tilordne roboter i listen til meg',
  Search: 'Søk',
  Filter: 'Filter',
  Customers: 'Kunder',
  Location: 'Lokasjon',
  Site: 'Nettstedet',
  Pen: 'Bur',
  TP: 'TP',
  Operator: 'Operatør',
  'Clear filter': 'Klart filter',
  'Apply filter': 'Bruk filter',
  'See less': 'Se mindre',
  'Show all': 'Vis alt',
  Robot: 'Robot',
  Status: 'Status',
  Mode: 'Modus',

  //Robot View
  'Network Status': 'Nettverksstatus',
  'Open BlueOS Video Manager': 'Åpne BlueOS Video Manager',
  'Lock for maintenance': 'Lås for vedlikehold',
  'Auto hours last 7 days': 'Auto timer siste 7 dager',
  'Customer name': 'Kundenavn',
  'Site name': 'Side navn',
  'Pen number': 'Pennnummer',
  'Pen type': 'Pentype',
  Position: 'Posisjon',
  Pattern: 'Mønster',
  Pass: 'Sende',
  None: 'Ingen',
  'Section point': 'Distribusjonspunkt',
  'Tether length': 'Tetherlengde',
  'Last connected': 'Sist tilkoblet',
  Depth: 'Dybde',
  Direction: 'Retning',
  Firmware: 'firmware_version',
  Note: 'Merk',
  Operation: 'Operasjon',
  Thrusters: 'Thrustere',
  Something: 'Noe',
  Date: 'Dato',
  TimeLine: 'Tidslinje',
  'Auto Hours': 'Auto timer',

  'Disable maintenance': 'Deaktiver vedlikehold',
  'Unassign robot from me': 'Unassign robot fra meg',
  'Assign robot to me': 'Tilordne robot til meg',
  'Show less': 'Vis mindre',
  'Show more': 'Vis mer',
  'You may leave notes for this tp here':
    'Du kan legge igjen notater for denne TP her',

  'Robot in': 'Robot i',
  From: 'Fra',
  To: 'Til',
  'Depth [m]': 'Dybde [m]',
  'Position [deg]': 'Posisjon [deg]',
  'Days since last pass': 'Dager siden siste passering',
  'Pen depth': 'Penndybdeh',
  'Search by location and tp': 'Søk etter sted og tp',

  Time: 'Tid',
  'View and configure data': 'Vis og konfigurere dataa',
  'GPS active': 'GPS aktive',

  'Go to linked robot': 'Gå til Linked Robott',

  '+ Pen section': '+ PEN -distribusjon',
  'Add pen deployment': 'Legg til pennedistribusjon',
  'Edit pen deployment': 'Rediger penndistribusjon',
  'Tether lenght (m)': 'Tether Lenght (m)',
  'Top box position': 'Toppboks -plassering',
  'Max depth (m)': 'Maks dybde (m)',
  'Degree from': 'Grad fra',
  'Degree to': 'Grad til',
  'Coordinate East': 'Koordinere øst',
  'Coordinate North': 'Koordinere nord',
  Coordinates: 'Koordinater',

  Id: 'Id',
  'Paired TP': 'Sammenkoblet TP',
  'Add new robot': 'Legg til ny robot',
  'Add robot': 'Legg til robot',
  'Robot number': 'Robotnummer',

  'Start flush in pen': 'Begynn å spyle i pennen',
  'Stop flush in pen': 'Slutt å skylle i pennen',

  Rec: 'rec',
  Stop: 'Stoppe',
  Overview: 'Oversikt',
  'Download the PDF': 'Eksporter PDF',
  'Net Damage': 'Notskade',
  'Copy link': 'Kopier lenke',
  'Time (CET)': 'Tidspunkt (CET)',
  Size: 'Størrelse',
  'Confirm set': 'Bekreft sett',
  'Major net damage': 'Stor notskade',
  'Small net damage': 'Liten notskade',
  Deviation: 'Avvik',
  Description: 'Beskrivelse',
  New: 'NY',
  Confirmed: 'Bekreftet',
  Discovered: 'Oppdaget',
  masks: 'masker',
  'No results found': 'Ingen avvik',
  'An error occurred while loading data':
    'En feil oppstod under lasting av data',
  'Link copied to clipboard!': 'Lenke kopiert!',
  'Confirmed the hole': 'Avvik bekreftet',
  'Unable to update, Please try again later':
    'Kan ikke oppdatere. Prøv igjen senere',
  'Access denied, No permissions': 'Tilgang nektet, ingen tillatelser',
  'is in normal operation': 'er i normal drift',
  'operating normally last week': 'i normal drift sist uke',
  of: 'av',
  'Number of robots that are in normal operation right now.':
    'Antall roboter som er i normal drift akkurat nå.',
  'How many robots are connected (online) and not in maintenance mode.':
    'Hvor mange roboter som er tilkoblet (online) og ikke i vedlikeholds modus.',
  'How much of the time the robots have been in normal operation in the last 7 days.':
    'Hvor mye av tidene robotene har vært i normal drift siste 7 dager.',
  'Operational settings': 'Driftsinnstillinger',
  'Unable to update mode, Please try again later':
    'Kan ikke oppdatere modus, prøv igjen senere',
  'Mode updated successfully': 'Modus oppdatert',
  'Unable to update mode because link for it is not available':
    'Kan ikke oppdatere modus fordi lenken ikke er tilgjengelig',
  'We are not able to communicate with the GNSS api for this robot':
    'Vi klarer ikke å kommunisere med GNSS-API-et for denne roboten',
  'Confirm GNSS state change?': 'Bekreft endring av GNSS-tilstand?',
  Confirm: 'Bekreft',
  'Are you sure you want to change the GNSS state?':
    'Er du sikker på at du vil endre GNSS-tilstanden?',
  'Hide menu': 'Skjul meny',
  'Log out': 'Logg ut',
  'Active Robots': 'Aktive roboter',
  Auto: 'Auto',
  Manual: 'Manuell',
  Offline: 'Frakoblet',
  Flushing: 'Spyling',
  Maintenance: 'Vedlikehold',
  Hold: 'Stopp',
  'GNSS Settings': 'GNSS-innstillinger',
  'TP GNSS configuration': 'TP GNSS-konfigurasjon',
  'Error in completing the setup': 'Feil ved fullføring av oppsettet',
  'Successfully completed the setup': 'Oppsettet ble fullført',
  'Unable to complete the setup. Link for it is not available':
    'Kan ikke fullføre oppsettet. Lenke er ikke tilgjengelig',
  Cancel: 'Avbryt',
  'Completed setup': 'Oppsett fullført',
  'Complete setup': 'Fullfør oppsett',
  'Everything is fine with the cages.': 'Alt står bra til med burene.',
  'We have not detected any deviations.': 'Vi har ikke oppdaget noen avvik.',
  Continue: 'Fortsette',
  'Language changed successfully.': 'Språket ble endret.',
  'Auto-schedule has also been disabled':
    'Automatisk planlegging er også deaktivert',
  'Disabling auto-schedule automatically has failed':
    'Deaktivering av automatisk planlegging mislyktes',
  'Pen flushing started': 'Penneskylling startet',
  'Error in while change mode': 'Feil i endringsmodus under',
  'Auto schedule updated successfully': 'Auto schedule oppdatert',
  Delete: 'Slett',
  'Are you sure about you want to delete this item?':
    'Er du sikker på at du vil slette dette elementet?',
  "Some edits in the GNSS setup or measurement list haven't been saved. Don’t forget to save them to avoid losing progress.":
    'Noen endringer i GNSS-oppsettet eller målelisten er ikke lagret. Husk å lagre dem for å unngå å miste fremdrift.',
  'Changes not yet saved': 'Endringer er ikke lagret ennå',
  'GNSS Setup Completed': 'GNSS-oppsett fullført',
  'GNSS Setup Incomplete': 'GNSS-oppsett ufullstendig',
  'Select an option': 'Velg et alternativ',
  'Customer Portal': 'Kundeportal',
  Support: 'Brukerstøtte',
  'Something went wrong while loading the overview.':
    'Noe gikk galt under lasting av oversikten.',
  'Create Jira Ticket': 'Opprett Jira-sak',
  'Create Jira Engineering Request': 'Opprett Jira-ingeniørforespørsel',
  'Create Jira Robot Incident': 'Opprett Jira-robotincident',
  Insight: 'Insight',
  'No id found, Unable to render graph':
    'Ingen ID funnet, kan ikke gjengi grafen',
  'Score map': 'Notkart',
  'Growing trend': 'Groe trend',
  Deviations: 'Avvik',
  'All deviation types': 'Alle avvikstyper',
  'New deviations': 'Nye avvik',
  'Note Information': 'Notinformasjon',
};

export const translatedStrings = Object.keys(noJSON);

export type TranslatableString = keyof typeof noJSON;

export default noJSON;
